export const enum EventLogsObjectType {
    RawMaterial = 0,
    Article = 1,
    Contact = 2,
    Company = 3,
    Subcontractor = 4,
    Project = 5,
    ProjectVisit = 6,
    ProjectReport = 7,
    Measurement = 8,
    Quotation = 9,
    MeasuringState = 10,
    Contract = 11,
    ProgressStatement = 12,
    Invoice = 13,
    Task = 14,
    File = 15,
    Settings = 16,
    ActionPoint = 17,
    MachineryProfile = 18,
    MachineryEvent = 19,
    Machinery = 20,
    MachineryEventType = 21,
    MachineryRental = 22,
    Job = 23,
    CreditNote = 24,
    Order = 25,
    ExternalInvoice = 26,
}

export const enum EventLogActions {
    // Basic actions
    Created = 0,
    Updated = 1,
    Deleted = 2,
    Completed = 3,
    Accepted = 4,
    Declined = 5,
    Duplicated = 6,
    // User actions > 50
    Note = 50,
    Mail = 51,
    PhoneCall = 52,
    // Files
    FileCreated = 70,
    FileUpdated = 71,
    FileDeleted = 72,
    // System Actions > 1000
    Report = 1001,
}
